<template>
  <div class="page-form page-base">
    <h3 class="title">销售计划汇总显示</h3>

    <div class="form-container">
      <div class="tools">
        <form-button @click="$emit('change-action', 'list')">返回</form-button>
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        disabled
        label-width="100px"
        :model="conditions"
        :show-message="false"
      >
        <common-title title="计划维度" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input :value="conditions.cust_name" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-input :value="conditions.customer_type_text" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="计划类型">
              <el-input :value="conditions.plan_type_text" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="存货分类">
              <el-input :value="conditions.wlybrand_text" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="年度">
              <el-input :value="conditions.gjahr" />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="区域" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="营销单元">
              <el-input :value="conditions.sal_center_text" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="省区">
              <el-input :value="conditions.region_text" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="城市">
              <el-input :value="conditions.city_text" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="业务员">
              <el-input :value="conditions.sales_emp_name" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="销售计划汇总明细" :custome-config="() => vxeShowCustom('xTable')">
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'medium' }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #plan_number="{row}">
            <span class="blue" @click="toDetail(row.plan_number)">{{ row.plan_number }}</span>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>
  </div>
</template>
<script>
// import { apiSalePlanCountDetail } from '@/api/sap/sale-plan'
export default {
  props: {
    rowData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      conditions: {},
      gridOptions: {
        data: [],
        columns: [
          { field: 'plan_number', title: '销售计划编号', width: 120, slots: { default: 'plan_number' }},
          { field: 'report_type_text', title: '提报类型', width: 120 },
          { field: 'monat', title: '月份', width: 120 },
          { field: 'total_qty', title: '总计划量', width: 120 },
          { field: 'initplan_qty', title: '初始计划量', width: 120 },
          { field: 'atp_qty', title: '已占用计划量', width: 120 },
          { field: 'billing_qty', title: '已开票计划量', width: 120 },
          { field: 'remain_qty', title: '剩余可用计划量', width: 120 },
          { field: 'total_amt', title: '总计划额', width: 120 },
          { field: 'initplan_amt', title: '初始计划额', width: 120 },
          { field: 'atp_amt', title: '已占用计划额', width: 120 },
          { field: 'billing_amt', title: '已开票计划额', width: 120 },
          { field: 'remain_amt', title: '剩余可用计划额', width: 120 }
        ]
      }
    }
  },
  created() {
    this.conditions = this.rowData
    this.gridOptions.data = this.rowData.items
  },
  methods: {
    toDetail(plan_number) {
      this.$router.push({
        path: '/wly/sale-plan/sale-plan-query',
        query: {
          action: 'detail',
          planNum: plan_number
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/components/salePlanCountDetail.vue